import { msalConfig } from '../../config/authConfig';
import { createAxiosInstance } from "./client";
import { PublicClientApplication } from "@azure/msal-browser";

const msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig);
const axiosInstance = createAxiosInstance(msalInstance);
const ENDPOINT = '/user';

export async function getUserByUuid(uuid) {
  try {
    const response = await axiosInstance.get(`${ENDPOINT}/${uuid}`);
    return response.data.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la récupération de l'utilisateur.");
  }
}

export async function getUsers() {
  try {
    const response = await axiosInstance.get(`${ENDPOINT}`);
    return response?.data?.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la récupération de la liste des utilisateurs.");
  }
}

export async function enforcePolicy(uuid, target, action = "GET") {
  try {
    const config = {
      params: {
        target: target,
        action: action,
      },
    };
    const response = await axiosInstance.get(`${ENDPOINT}/${uuid}/policy`, config);
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error("Erreur lors de la vérificaton d'une permission.");
  }
}
